var $9eb56bbbe8e31294$exports = {};
$9eb56bbbe8e31294$exports = {
  "removeDescription": "Press Delete to remove tag.",
  "removeButtonLabel": "Remove"
};
export { $9eb56bbbe8e31294$exports as default };